// generated with https://csvjson.com/csv2json from combined spreadsheet

import { operations } from "./openapi/generated-types.ts";

type CreatePlayer =
  operations["player.write.create"]["requestBody"]["content"]["application/json"];

export const players: (Omit<CreatePlayer, "teamId" | "id"> & {
  teamShortName: string;
})[] = [
  {
    number: 1,
    firstName: "Teo",
    lastName: "Fehling",
    birthday: "2009-12-11",
    isGoalkeeper: true,
    teamShortName: "mka",
  },
  {
    number: 2,
    firstName: "Berat",
    lastName: "Bodur",
    birthday: "2010-10-18",
    isGoalkeeper: false,
    teamShortName: "mka",
  },
  {
    number: 3,
    firstName: "Robin",
    lastName: "Johanning",
    birthday: "2009-06-10",
    isGoalkeeper: false,
    teamShortName: "mka",
  },
  {
    number: 4,
    firstName: "Pelle",
    lastName: "Heineking",
    birthday: "2010-08-24",
    isGoalkeeper: false,
    teamShortName: "mka",
  },
  {
    number: 5,
    firstName: "Noah",
    lastName: "Jedral",
    birthday: "2010-09-02",
    isGoalkeeper: false,
    teamShortName: "mka",
  },
  {
    number: 6,
    firstName: "Marlin",
    lastName: "Witt",
    birthday: "2010-04-21",
    isGoalkeeper: false,
    teamShortName: "mka",
  },
  {
    number: 7,
    firstName: "Yousef",
    lastName: "Fakih",
    birthday: "2009-02-25",
    isGoalkeeper: false,
    teamShortName: "mka",
  },
  {
    number: 8,
    firstName: "Vincenzo",
    lastName: "Rosanova",
    birthday: "2010-04-14",
    isGoalkeeper: false,
    teamShortName: "mka",
  },
  {
    number: 9,
    firstName: "Adnan",
    lastName: "Aziraj",
    birthday: "2009-05-26",
    isGoalkeeper: false,
    teamShortName: "mka",
  },
  {
    number: 10,
    firstName: "Maik",
    lastName: "Siemens",
    birthday: "2009-10-05",
    isGoalkeeper: false,
    teamShortName: "mka",
  },
  {
    number: 11,
    firstName: "Vincent",
    lastName: "Eickermann",
    birthday: "2009-06-05",
    isGoalkeeper: false,
    teamShortName: "mka",
  },
  {
    number: 13,
    firstName: "Laurenz",
    lastName: "Heitkamp",
    birthday: "2009-02-14",
    isGoalkeeper: false,
    teamShortName: "mka",
  },
  {
    number: 22,
    firstName: "Hannes",
    lastName: "Bobbe",
    birthday: "2010-04-14",
    isGoalkeeper: true,
    teamShortName: "rbl",
  },
  {
    number: 19,
    firstName: "Oscar",
    lastName: "Guerrier",
    birthday: "2011-01-14",
    isGoalkeeper: false,
    teamShortName: "rbl",
  },
  {
    number: 15,
    firstName: "Oskar",
    lastName: "Lange",
    birthday: "2010-05-27",
    isGoalkeeper: false,
    teamShortName: "rbl",
  },
  {
    number: 14,
    firstName: "Erik",
    lastName: "Gulden",
    birthday: "2010-06-01",
    isGoalkeeper: false,
    teamShortName: "rbl",
  },
  {
    number: 12,
    firstName: "Koby",
    lastName: "Ay",
    birthday: "2010-08-06",
    isGoalkeeper: false,
    teamShortName: "rbl",
  },
  {
    number: 11,
    firstName: "Fyn",
    lastName: "Georgi",
    birthday: "2010-05-27",
    isGoalkeeper: false,
    teamShortName: "rbl",
  },
  {
    number: 18,
    firstName: "Moritz",
    lastName: "Tischler",
    birthday: "2010-06-18",
    isGoalkeeper: false,
    teamShortName: "rbl",
  },
  {
    number: 9,
    firstName: "Paul",
    lastName: "Dohrmann",
    birthday: "2010-05-29",
    isGoalkeeper: false,
    teamShortName: "rbl",
  },
  {
    number: 7,
    firstName: "Nils",
    lastName: "Bienwald",
    birthday: "2011-04-19",
    isGoalkeeper: false,
    teamShortName: "rbl",
  },
  {
    number: 6,
    firstName: "Jannis Tanay",
    lastName: "Altinok",
    birthday: "2010-04-22",
    isGoalkeeper: false,
    teamShortName: "rbl",
  },
  {
    number: 5,
    firstName: "Karl",
    lastName: "Erhart",
    birthday: "2010-01-20",
    isGoalkeeper: false,
    teamShortName: "rbl",
  },
  {
    number: 34,
    firstName: "Emirhan",
    lastName: "Karabulut",
    birthday: "2010-01-01",
    isGoalkeeper: false,
    teamShortName: "b04",
  },
  {
    number: 44,
    firstName: "Obaid",
    lastName: "Saidi",
    birthday: "2010-01-08",
    isGoalkeeper: false,
    teamShortName: "b04",
  },
  {
    number: 46,
    firstName: "Noah",
    lastName: "Behr",
    birthday: "2010-01-09",
    isGoalkeeper: false,
    teamShortName: "b04",
  },
  {
    number: 40,
    firstName: "Redon",
    lastName: "Pervetica",
    birthday: "2010-01-27",
    isGoalkeeper: false,
    teamShortName: "b04",
  },
  {
    number: 43,
    firstName: "Edmond",
    lastName: "Manga",
    birthday: "2010-03-30",
    isGoalkeeper: false,
    teamShortName: "b04",
  },
  {
    number: 12,
    firstName: "Yaron",
    lastName: "Ommer",
    birthday: "2010-04-29",
    isGoalkeeper: true,
    teamShortName: "b04",
  },
  {
    number: 29,
    firstName: "Valon",
    lastName: "Bedzeti",
    birthday: "2010-05-18",
    isGoalkeeper: false,
    teamShortName: "b04",
  },
  {
    number: 39,
    firstName: "Louis",
    lastName: "Lomboy",
    birthday: "2010-06-19",
    isGoalkeeper: false,
    teamShortName: "b04",
  },
  {
    number: 45,
    firstName: "Yusa",
    lastName: "Ayranci",
    birthday: "2010-07-09",
    isGoalkeeper: false,
    teamShortName: "b04",
  },
  {
    number: 42,
    firstName: "Alexander",
    lastName: "Neitzsch",
    birthday: "2010-07-29",
    isGoalkeeper: false,
    teamShortName: "b04",
  },
  {
    number: 27,
    firstName: "Samuel",
    lastName: "Guie-Mien",
    birthday: "2010-08-01",
    isGoalkeeper: false,
    teamShortName: "b04",
  },
  {
    number: 1,
    firstName: "Joshua",
    lastName: "Amthor",
    birthday: "2010-10-01",
    isGoalkeeper: true,
    teamShortName: "b04",
  },
  {
    number: 1,
    firstName: "Ben",
    lastName: "Schlieper",
    birthday: "2010-01-17",
    isGoalkeeper: true,
    teamShortName: "s04",
  },
  {
    number: 25,
    firstName: "Burak",
    lastName: "Uzun",
    birthday: "2010-06-30",
    isGoalkeeper: true,
    teamShortName: "s04",
  },
  {
    number: 3,
    firstName: "Luis",
    lastName: "Tönges",
    birthday: "2010-06-14",
    isGoalkeeper: false,
    teamShortName: "s04",
  },
  {
    number: 4,
    firstName: "Jonas",
    lastName: "Eckard",
    birthday: "2010-01-22",
    isGoalkeeper: false,
    teamShortName: "s04",
  },
  {
    number: 5,
    firstName: "Mikail",
    lastName: "Yüksel",
    birthday: "2010-02-04",
    isGoalkeeper: false,
    teamShortName: "s04",
  },
  {
    number: 6,
    firstName: "Levin",
    lastName: "Ertural",
    birthday: "2010-09-01",
    isGoalkeeper: false,
    teamShortName: "s04",
  },
  {
    number: 7,
    firstName: "Antonio",
    lastName: "Lombardi",
    birthday: "2010-08-01",
    isGoalkeeper: false,
    teamShortName: "s04",
  },
  {
    number: 8,
    firstName: "Riyad",
    lastName: "Ouedraogo",
    birthday: "2010-05-28",
    isGoalkeeper: false,
    teamShortName: "s04",
  },
  {
    number: 9,
    firstName: "Fynn",
    lastName: "de Vries",
    birthday: "2010-02-27",
    isGoalkeeper: false,
    teamShortName: "s04",
  },
  {
    number: 10,
    firstName: "Miran",
    lastName: "Turan",
    birthday: "2010-07-06",
    isGoalkeeper: false,
    teamShortName: "s04",
  },
  {
    number: 11,
    firstName: "Micheal",
    lastName: "Omorogbe",
    birthday: "2010-12-30",
    isGoalkeeper: false,
    teamShortName: "s04",
  },
  {
    number: 20,
    firstName: "Adonai",
    lastName: "Quiala",
    birthday: "2010-05-11",
    isGoalkeeper: false,
    teamShortName: "bsc",
  },
  {
    number: 11,
    firstName: "Constantin",
    lastName: "Kanne",
    birthday: "2010-02-07",
    isGoalkeeper: false,
    teamShortName: "bsc",
  },
  {
    number: 23,
    firstName: "Dion",
    lastName: "Nedzipi",
    birthday: "2010-06-28",
    isGoalkeeper: false,
    teamShortName: "bsc",
  },
  {
    number: 4,
    firstName: "Ferdinand",
    lastName: "Brune",
    birthday: "2010-05-31",
    isGoalkeeper: false,
    teamShortName: "bsc",
  },
  {
    number: 2,
    firstName: "Luan",
    lastName: "Schulz",
    birthday: "2010-05-22",
    isGoalkeeper: false,
    teamShortName: "bsc",
  },
  {
    number: 5,
    firstName: "Leon",
    lastName: "Kerber",
    birthday: "2010-03-02",
    isGoalkeeper: false,
    teamShortName: "bsc",
  },
  {
    number: 14,
    firstName: "Maurice",
    lastName: "Liedkte",
    birthday: "2010-02-14",
    isGoalkeeper: false,
    teamShortName: "bsc",
  },
  {
    number: 21,
    firstName: "Ole",
    lastName: "Jandke",
    birthday: "2010-03-04",
    isGoalkeeper: false,
    teamShortName: "bsc",
  },
  {
    number: 17,
    firstName: "Yahya Salih",
    lastName: "Oktas",
    birthday: "2010-02-10",
    isGoalkeeper: false,
    teamShortName: "bsc",
  },
  {
    number: 1,
    firstName: "Paul",
    lastName: "Küpper",
    birthday: "2010-07-21",
    isGoalkeeper: true,
    teamShortName: "bsc",
  },
  {
    number: 15,
    firstName: "Julian-Maxime",
    lastName: "Wenta",
    birthday: "2010-04-28",
    isGoalkeeper: false,
    teamShortName: "bsc",
  },
  {
    number: 1,
    firstName: "Oskar",
    lastName: "Bartel",
    birthday: "2010-02-20",
    isGoalkeeper: true,
    teamShortName: "fcu",
  },
  {
    number: 6,
    firstName: "Hewal",
    lastName: "Kümet",
    birthday: "2010-05-27",
    isGoalkeeper: false,
    teamShortName: "fcu",
  },
  {
    number: 7,
    firstName: "Pierre",
    lastName: "Kluck",
    birthday: "2010-04-11",
    isGoalkeeper: false,
    teamShortName: "fcu",
  },

  {
    number: 9,
    firstName: "Nikodem",
    lastName: "Kotynia",
    birthday: "2010-01-05",
    isGoalkeeper: false,
    teamShortName: "fcu",
  },
  {
    number: 10,
    firstName: "Luka",
    lastName: "Samardzic",
    birthday: "2010-01-19",
    isGoalkeeper: false,
    teamShortName: "fcu",
  },
  {
    number: 11,
    firstName: "Jonathan",
    lastName: "Mücke",
    birthday: "2010-03-05",
    isGoalkeeper: false,
    teamShortName: "fcu",
  },

  {
    number: 18,
    firstName: "Rafael",
    lastName: "Schumski",
    birthday: "2010-07-27",
    isGoalkeeper: false,
    teamShortName: "fcu",
  },
  {
    number: 19,
    firstName: "Johannes",
    lastName: "Bading",
    birthday: "2010-03-21",
    isGoalkeeper: false,
    teamShortName: "fcu",
  },
  {
    number: 22,
    firstName: "Johan",
    lastName: "Falck",
    birthday: "2010-03-03",
    isGoalkeeper: false,
    teamShortName: "fcu",
  },
  {
    number: 23,
    firstName: "Kian",
    lastName: "Catak",
    birthday: "2010-06-23",
    isGoalkeeper: false,
    teamShortName: "fcu",
  },
  {
    number: 1,
    firstName: "Max",
    lastName: "Lubitz",
    birthday: "2010-02-18",
    isGoalkeeper: true,
    teamShortName: "svw",
  },
  {
    number: 20,
    firstName: "Bennet",
    lastName: "Meyer",
    birthday: "2010-11-22",
    isGoalkeeper: true,
    teamShortName: "svw",
  },
  {
    number: 19,
    firstName: "Bennet",
    lastName: "Kiel",
    birthday: "2010-01-21",
    isGoalkeeper: false,
    teamShortName: "svw",
  },
  {
    number: 4,
    firstName: "Ben",
    lastName: "Wagner",
    birthday: "2010-02-06",
    isGoalkeeper: false,
    teamShortName: "svw",
  },
  {
    number: 10,
    firstName: "Nils",
    lastName: "Ersfeld",
    birthday: "2010-02-16",
    isGoalkeeper: false,
    teamShortName: "svw",
  },
  {
    number: 16,
    firstName: "Adrian",
    lastName: "Japs",
    birthday: "2010-06-18",
    isGoalkeeper: false,
    teamShortName: "svw",
  },
  {
    number: 17,
    firstName: "Davi",
    lastName: "dos Santos Tetzner",
    birthday: "2010-03-06",
    isGoalkeeper: false,
    teamShortName: "svw",
  },
  {
    number: 11,
    firstName: "Mahamud",
    lastName: "Mahamud",
    birthday: "2010-03-04",
    isGoalkeeper: false,
    teamShortName: "svw",
  },
  {
    number: 18,
    firstName: "Anton",
    lastName: "Finnern",
    birthday: "2010-04-27",
    isGoalkeeper: false,
    teamShortName: "svw",
  },
  {
    number: 6,
    firstName: "Adis",
    lastName: "Mehic",
    birthday: "2010-04-27",
    isGoalkeeper: false,
    teamShortName: "svw",
  },
  {
    number: 25,
    firstName: "Jerry",
    lastName: "Oguns",
    birthday: "2010-01-11",
    isGoalkeeper: false,
    teamShortName: "svw",
  },
  {
    number: 7,
    firstName: "Noah",
    lastName: "Mazur",
    birthday: "2010-06-11",
    isGoalkeeper: false,
    teamShortName: "svw",
  },
  {
    number: 1,
    firstName: "Josha",
    lastName: "Juskowiak",
    birthday: "2010-06-21",
    isGoalkeeper: true,
    teamShortName: "boc",
  },
  {
    number: 6,
    firstName: "Kim Noah",
    lastName: "Matulin",
    birthday: "2010-03-09",
    isGoalkeeper: false,
    teamShortName: "boc",
  },
  {
    number: 7,
    firstName: "Wail",
    lastName: "Akkouh ElMoussaoui",
    birthday: "2010-02-17",
    isGoalkeeper: false,
    teamShortName: "boc",
  },
  {
    number: 9,
    firstName: "Jonas",
    lastName: "Simon",
    birthday: "2010-01-03",
    isGoalkeeper: false,
    teamShortName: "boc",
  },
  {
    number: 10,
    firstName: "Elmin",
    lastName: "Kojic",
    birthday: "2010-12-10",
    isGoalkeeper: false,
    teamShortName: "boc",
  },
  {
    number: 11,
    firstName: "Selim",
    lastName: "Paravlic",
    birthday: "2010-02-21",
    isGoalkeeper: false,
    teamShortName: "boc",
  },
  {
    number: 12,
    firstName: "Etienne",
    lastName: "Krebo",
    birthday: "2010-02-21",
    isGoalkeeper: false,
    teamShortName: "boc",
  },
  {
    number: 15,
    firstName: "Deniz",
    lastName: "Akbulutlar",
    birthday: "2010-03-07",
    isGoalkeeper: false,
    teamShortName: "boc",
  },
  {
    number: 16,
    firstName: "Mathis",
    lastName: "Quent",
    birthday: "2010-04-01",
    isGoalkeeper: false,
    teamShortName: "boc",
  },
  {
    number: 18,
    firstName: "Tom",
    lastName: "Wrobel",
    birthday: "2010-12-29",
    isGoalkeeper: true,
    teamShortName: "boc",
  },
  {
    number: 20,
    firstName: "Marc",
    lastName: "Guilavogui",
    birthday: "2010-04-06",
    isGoalkeeper: false,
    teamShortName: "boc",
  },
  {
    number: 1,
    firstName: "Emilio",
    lastName: "Falkenstein",
    birthday: "2010-11-26",
    isGoalkeeper: true,
    teamShortName: "koe",
  },
  {
    number: 12,
    firstName: "Roman",
    lastName: "Inden",
    birthday: "2010-02-14",
    isGoalkeeper: true,
    teamShortName: "koe",
  },
  {
    number: 10,
    firstName: "Yassin",
    lastName: "Tollih",
    birthday: "2010-07-26",
    isGoalkeeper: false,
    teamShortName: "koe",
  },
  {
    number: 11,
    firstName: "Ismaïla",
    lastName: "Diallo",
    birthday: "2010-05-31",
    isGoalkeeper: false,
    teamShortName: "koe",
  },
  {
    number: 7,
    firstName: "Laurenz",
    lastName: "Imping",
    birthday: "2011-01-18",
    isGoalkeeper: false,
    teamShortName: "koe",
  },
  {
    number: 9,
    firstName: "Loic",
    lastName: "Mballa",
    birthday: "2010-04-21",
    isGoalkeeper: false,
    teamShortName: "koe",
  },
  {
    number: 2,
    firstName: "Leart",
    lastName: "Himaj",
    birthday: "2010-04-22",
    isGoalkeeper: false,
    teamShortName: "koe",
  },
  {
    number: 8,
    firstName: "Jaylen",
    lastName: "Potgieter",
    birthday: "2010-02-12",
    isGoalkeeper: false,
    teamShortName: "koe",
  },
  {
    number: 3,
    firstName: "Ben",
    lastName: "Rainartz",
    birthday: "2010-05-03",
    isGoalkeeper: false,
    teamShortName: "koe",
  },
  {
    number: 6,
    firstName: "Alex",
    lastName: "Schröder",
    birthday: "2010-02-26",
    isGoalkeeper: false,
    teamShortName: "koe",
  },
  {
    number: 13,
    firstName: "Lion",
    lastName: "Dakaj",
    birthday: "2010-03-04",
    isGoalkeeper: false,
    teamShortName: "koe",
  },
  {
    number: 14,
    firstName: "Julian",
    lastName: "Stange",
    birthday: "2010-06-30",
    isGoalkeeper: false,
    teamShortName: "koe",
  },
  {
    number: 1,
    firstName: "Nelio",
    lastName: "Kock",
    birthday: "2010-10-20",
    isGoalkeeper: true,
    teamShortName: "hsv",
  },
  {
    number: 5,
    firstName: "Milo",
    lastName: "Kühnemund",
    birthday: "2010-05-17",
    isGoalkeeper: false,
    teamShortName: "hsv",
  },
  {
    number: 8,
    firstName: "Stefanos",
    lastName: "Chrysovitsiotis",
    birthday: "2010-09-08",
    isGoalkeeper: false,
    teamShortName: "hsv",
  },
  {
    number: 10,
    firstName: "Hamza",
    lastName: "Miry",
    birthday: "2010-05-23",
    isGoalkeeper: false,
    teamShortName: "hsv",
  },
  {
    number: 16,
    firstName: "Lasse",
    lastName: "Wiemann",
    birthday: "2010-07-29",
    isGoalkeeper: false,
    teamShortName: "hsv",
  },
  {
    number: 18,
    firstName: "Jan",
    lastName: "Kobas",
    birthday: "2010-08-18",
    isGoalkeeper: false,
    teamShortName: "hsv",
  },
  {
    number: 20,
    firstName: "Alex",
    lastName: "Lawandi",
    birthday: "2010-04-25",
    isGoalkeeper: false,
    teamShortName: "hsv",
  },
  {
    number: 22,
    firstName: "Dionart",
    lastName: "Miroci",
    birthday: "2010-12-27",
    isGoalkeeper: false,
    teamShortName: "hsv",
  },
  {
    number: 27,
    firstName: "Anton",
    lastName: "Gasch",
    birthday: "2010-05-27",
    isGoalkeeper: false,
    teamShortName: "hsv",
  },
  {
    number: 28,
    firstName: "Sherrod",
    lastName: "McCoyne",
    birthday: "2010-05-14",
    isGoalkeeper: false,
    teamShortName: "hsv",
  },
  {
    number: 1,
    firstName: "Etienne",
    lastName: "Noe",
    birthday: "2010-02-21",
    isGoalkeeper: true,
    teamShortName: "m05",
  },
  {
    number: 2,
    firstName: "Jonas",
    lastName: "Berkhoff",
    birthday: "2010-06-19",
    isGoalkeeper: false,
    teamShortName: "m05",
  },
  {
    number: 4,
    firstName: "Jona",
    lastName: "Strub",
    birthday: "2010-02-27",
    isGoalkeeper: false,
    teamShortName: "m05",
  },
  {
    number: 5,
    firstName: "Zinedine",
    lastName: "Hadzic",
    birthday: "2010-03-06",
    isGoalkeeper: false,
    teamShortName: "m05",
  },
  {
    number: 6,
    firstName: "Louay",
    lastName: "Ichaoui",
    birthday: "2010-09-01",
    isGoalkeeper: false,
    teamShortName: "m05",
  },
  {
    number: 7,
    firstName: "Anthony",
    lastName: "Applewhaite",
    birthday: "2010-10-31",
    isGoalkeeper: false,
    teamShortName: "m05",
  },
  {
    number: 8,
    firstName: "Felix",
    lastName: "Cemeras",
    birthday: "2010-05-19",
    isGoalkeeper: false,
    teamShortName: "m05",
  },
  {
    number: 9,
    firstName: "Paul",
    lastName: "Bertsch",
    birthday: "2010-02-23",
    isGoalkeeper: false,
    teamShortName: "m05",
  },
  {
    number: 10,
    firstName: "Hoyoung",
    lastName: "Lee",
    birthday: "2010-03-23",
    isGoalkeeper: false,
    teamShortName: "m05",
  },
  {
    number: 11,
    firstName: "Dimitrios",
    lastName: "Chorosis",
    birthday: "2010-06-21",
    isGoalkeeper: false,
    teamShortName: "m05",
  },
  {
    number: 1,
    firstName: "Bendix",
    lastName: "Dankwerth",
    birthday: "2010-01-25",
    isGoalkeeper: true,
    teamShortName: "dsc",
  },
  {
    number: 12,
    firstName: "Maximilian",
    lastName: "Bechtold",
    birthday: "2010-03-14",
    isGoalkeeper: true,
    teamShortName: "dsc",
  },
  {
    number: 6,
    firstName: "Niklas",
    lastName: "Kollmeier",
    birthday: "2010-01-25",
    isGoalkeeper: false,
    teamShortName: "dsc",
  },
  {
    number: 7,
    firstName: "Maikel",
    lastName: "Keba",
    birthday: "2010-01-01",
    isGoalkeeper: false,
    teamShortName: "dsc",
  },
  {
    number: 10,
    firstName: "Luka",
    lastName: "Jakovic",
    birthday: "2010-10-06",
    isGoalkeeper: false,
    teamShortName: "dsc",
  },
  {
    number: 13,
    firstName: "Jonas",
    lastName: "Skiba",
    birthday: "2010-03-10",
    isGoalkeeper: false,
    teamShortName: "dsc",
  },
  {
    number: 14,
    firstName: "Daniel",
    lastName: "Hoene",
    birthday: "2010-02-02",
    isGoalkeeper: false,
    teamShortName: "dsc",
  },
  {
    number: 15,
    firstName: "Tunay",
    lastName: "Yildirim",
    birthday: "2010-02-15",
    isGoalkeeper: false,
    teamShortName: "dsc",
  },
  {
    number: 16,
    firstName: "Denzel",
    lastName: "Eyengue",
    birthday: "2010-03-17",
    isGoalkeeper: false,
    teamShortName: "dsc",
  },
  {
    number: 17,
    firstName: "Noah",
    lastName: "Graziano",
    birthday: "2010-07-12",
    isGoalkeeper: false,
    teamShortName: "dsc",
  },
  {
    number: 19,
    firstName: "Luk",
    lastName: "Ewald",
    birthday: "2010-11-11",
    isGoalkeeper: false,
    teamShortName: "dsc",
  },
  {
    number: 20,
    firstName: "Blessed",
    lastName: "Okosun",
    birthday: "2010-08-02",
    isGoalkeeper: false,
    teamShortName: "dsc",
  },
  {
    number: 1,
    firstName: "Simon",
    lastName: "Urban",
    birthday: "2010-02-09",
    isGoalkeeper: true,
    teamShortName: "bmg",
  },
  {
    number: 2,
    firstName: "Maxim",
    lastName: "Lagos",
    birthday: "2010-08-03",
    isGoalkeeper: false,
    teamShortName: "bmg",
  },
  {
    number: 3,
    firstName: "Nils",
    lastName: "Peters",
    birthday: "2010-06-14",
    isGoalkeeper: false,
    teamShortName: "bmg",
  },
  {
    number: 4,
    firstName: "Paul",
    lastName: "Ingenfeld",
    birthday: "2010-02-17",
    isGoalkeeper: false,
    teamShortName: "bmg",
  },
  {
    number: 5,
    firstName: "Felix",
    lastName: "Schlösser",
    birthday: "2010-04-28",
    isGoalkeeper: false,
    teamShortName: "bmg",
  },
  {
    number: 6,
    firstName: "Piet",
    lastName: "Sautner",
    birthday: "2010-02-16",
    isGoalkeeper: false,
    teamShortName: "bmg",
  },
  {
    number: 7,
    firstName: "Kenny",
    lastName: "Vestjens",
    birthday: "2011-02-28",
    isGoalkeeper: false,
    teamShortName: "bmg",
  },
  {
    number: 8,
    firstName: "Johann",
    lastName: "Ngongang",
    birthday: "2010-02-10",
    isGoalkeeper: false,
    teamShortName: "bmg",
  },
  {
    number: 9,
    firstName: "Leo",
    lastName: "Doll",
    birthday: "2010-01-27",
    isGoalkeeper: false,
    teamShortName: "bmg",
  },
  {
    number: 10,
    firstName: "Filip",
    lastName: "Cirovic",
    birthday: "2010-09-03",
    isGoalkeeper: false,
    teamShortName: "bmg",
  },
  {
    number: 11,
    firstName: "Aldrin",
    lastName: "Asani",
    birthday: "2010-04-11",
    isGoalkeeper: false,
    teamShortName: "bmg",
  },
  {
    number: 30,
    firstName: "Florian",
    lastName: "Knoben",
    birthday: "2010-06-28",
    isGoalkeeper: true,
    teamShortName: "bmg",
  },
  {
    number: 1,
    firstName: "Bennet",
    lastName: "Birtner",
    birthday: "2010-01-04",
    isGoalkeeper: true,
    teamShortName: "bvb",
  },
  {
    number: 2,
    firstName: "Zisopoulos",
    lastName: "Georgios",
    birthday: "2010-01-17",
    isGoalkeeper: false,
    teamShortName: "bvb",
  },
  {
    number: 6,
    firstName: "Maximilian",
    lastName: "Klingenheben",
    birthday: "2010-01-08",
    isGoalkeeper: false,
    teamShortName: "bvb",
  },
  {
    number: 7,
    firstName: "Niclas",
    lastName: "Goldberg",
    birthday: "2010-01-09",
    isGoalkeeper: false,
    teamShortName: "bvb",
  },
  {
    number: 8,
    firstName: "Nikola",
    lastName: "Jekic",
    birthday: "2010-06-25",
    isGoalkeeper: false,
    teamShortName: "bvb",
  },
  {
    number: 9,
    firstName: "Hamzath",
    lastName: "Mohamadou",
    birthday: "2011-03-11",
    isGoalkeeper: false,
    teamShortName: "bvb",
  },
  {
    number: 10,
    firstName: "Jonas",
    lastName: "Schwarzer",
    birthday: "2010-08-02",
    isGoalkeeper: false,
    teamShortName: "bvb",
  },
  {
    number: 11,
    firstName: "Till",
    lastName: "Burkhardt",
    birthday: "2010-01-18",
    isGoalkeeper: false,
    teamShortName: "bvb",
  },
  {
    number: 12,
    firstName: "Jan",
    lastName: "Voschepoth",
    birthday: "2010-03-03",
    isGoalkeeper: true,
    teamShortName: "bvb",
  },
  {
    number: 15,
    firstName: "Emre",
    lastName: "Kirar",
    birthday: "2010-01-03",
    isGoalkeeper: false,
    teamShortName: "bvb",
  },
  {
    number: 17,
    firstName: "Keron",
    lastName: "Hagemann",
    birthday: "2010-02-19",
    isGoalkeeper: false,
    teamShortName: "bvb",
  },
  {
    number: 19,
    firstName: "Athanasios",
    lastName: "Grammozis",
    birthday: "2010-04-07",
    isGoalkeeper: false,
    teamShortName: "bvb",
  },
  {
    number: 5,
    firstName: "Ben",
    lastName: "Hermann",
    birthday: "2010-10-16",
    isGoalkeeper: false,
    teamShortName: "bvb",
  },
  {
    number: 16,
    firstName: "Tim-Bakary",
    lastName: "Bojang",
    birthday: "2010-05-19",
    isGoalkeeper: false,
    teamShortName: "bvb",
  },
  {
    number: 1,
    firstName: "Niko",
    lastName: "Rieger",
    birthday: "2010-08-06",
    isGoalkeeper: true,
    teamShortName: "vfb",
  },
  {
    number: 3,
    firstName: "Ivan",
    lastName: "Dominikovic",
    birthday: "2010-08-26",
    isGoalkeeper: false,
    teamShortName: "vfb",
  },
  {
    number: 5,
    firstName: "Enrico",
    lastName: "Petermichl",
    birthday: "2010-06-08",
    isGoalkeeper: false,
    teamShortName: "vfb",
  },
  {
    number: 6,
    firstName: "Kian",
    lastName: "Demez",
    birthday: "2010-04-22",
    isGoalkeeper: false,
    teamShortName: "vfb",
  },
  {
    number: 4,
    firstName: "Niko",
    lastName: "Petkovic",
    birthday: "2010-03-13",
    isGoalkeeper: false,
    teamShortName: "vfb",
  },
  {
    number: 11,
    firstName: "Julius",
    lastName: "De Carlo",
    birthday: "2010-05-03",
    isGoalkeeper: false,
    teamShortName: "vfb",
  },
  {
    number: 8,
    firstName: "Miguel",
    lastName: "Pohl",
    birthday: "2010-08-28",
    isGoalkeeper: false,
    teamShortName: "vfb",
  },
  {
    number: 7,
    firstName: "Guilherme",
    lastName: "Cordeiro",
    birthday: "2010-08-23",
    isGoalkeeper: false,
    teamShortName: "vfb",
  },
  {
    number: 10,
    firstName: "Adrian",
    lastName: "Belca",
    birthday: "2010-03-01",
    isGoalkeeper: false,
    teamShortName: "vfb",
  },
  {
    number: 9,
    firstName: "Aaron",
    lastName: "Iskrowicz",
    birthday: "2010-03-15",
    isGoalkeeper: false,
    teamShortName: "vfb",
  },
  {
    number: 1,
    firstName: "Amar",
    lastName: "Omerovic",
    birthday: "2010-07-13",
    isGoalkeeper: true,
    teamShortName: "fcb",
  },
  {
    number: 18,
    firstName: "Mark",
    lastName: "Kuzmuk",
    birthday: "2011-05-19",
    isGoalkeeper: true,
    teamShortName: "fcb",
  },
  {
    number: 8,
    firstName: "Vincent",
    lastName: "Maibach",
    birthday: "2011-08-10",
    isGoalkeeper: false,
    teamShortName: "fcb",
  },
  {
    number: 2,
    firstName: "Lamar",
    lastName: "Rama",
    birthday: "2010-01-14",
    isGoalkeeper: false,
    teamShortName: "fcb",
  },
  {
    number: 6,
    firstName: "Tarik",
    lastName: "Mujic",
    birthday: "2010-03-27",
    isGoalkeeper: false,
    teamShortName: "fcb",
  },
  {
    number: 7,
    firstName: "Deni",
    lastName: "Zubovic",
    birthday: "2010-08-14",
    isGoalkeeper: false,
    teamShortName: "fcb",
  },
  {
    number: 5,
    firstName: "Dmytro",
    lastName: "Tsebeniak",
    birthday: "2011-11-13",
    isGoalkeeper: false,
    teamShortName: "fcb",
  },
  {
    number: 9,
    firstName: "Daniel",
    lastName: "Abade",
    birthday: "2010-01-14",
    isGoalkeeper: false,
    teamShortName: "fcb",
  },
  {
    number: 3,
    firstName: "Niklas",
    lastName: "Herber",
    birthday: "2010-09-17",
    isGoalkeeper: false,
    teamShortName: "fcb",
  },
  {
    number: 10,
    firstName: "Franz",
    lastName: "Hoffmann",
    birthday: "2010-02-25",
    isGoalkeeper: false,
    teamShortName: "fcb",
  },
  {
    number: 11,
    firstName: "Dominik",
    lastName: "Strbac",
    birthday: "2011-02-16",
    isGoalkeeper: false,
    teamShortName: "fcb",
  },
  {
    number: 1,
    firstName: "Max",
    lastName: "Mohrmann",
    birthday: "2001-04-25",
    isGoalkeeper: true,
    teamShortName: "mer",
  },
  {
    number: 12,
    firstName: "Jonas",
    lastName: "Vogt",
    birthday: "2005-01-07",
    isGoalkeeper: true,
    teamShortName: "mer",
  },
  {
    number: 18,
    firstName: "Marvin",
    lastName: "Sandmeier",
    birthday: "2006-11-24",
    isGoalkeeper: false,
    teamShortName: "mer",
  },
  {
    number: 5,
    firstName: "Civan",
    lastName: "Ertem",
    birthday: "1999-03-20",
    isGoalkeeper: false,
    teamShortName: "mer",
  },
  {
    number: 17,
    firstName: "Daniel",
    lastName: "Klippenstein",
    birthday: "2006-08-05",
    isGoalkeeper: false,
    teamShortName: "mer",
  },
  {
    number: 8,
    firstName: "Tristan",
    lastName: "Zopf",
    birthday: "2005-04-02",
    isGoalkeeper: false,
    teamShortName: "mer",
  },
  {
    number: 9,
    firstName: "Justin",
    lastName: "Windmann",
    birthday: "2003-08-12",
    isGoalkeeper: false,
    teamShortName: "mer",
  },
  {
    number: 6,
    firstName: "Jason",
    lastName: "Wulf",
    birthday: "2006-05-09",
    isGoalkeeper: false,
    teamShortName: "mer",
  },
  {
    number: 7,
    firstName: "Noah",
    lastName: "Wolkensinger",
    birthday: "2007-08-22",
    isGoalkeeper: false,
    teamShortName: "mer",
  },
  {
    number: 13,
    firstName: "Oliver",
    lastName: "Carl",
    birthday: "1999-12-17",
    isGoalkeeper: false,
    teamShortName: "mer",
  },
  {
    number: 14,
    firstName: "Henrik",
    lastName: "Graß",
    birthday: "2003-06-01",
    isGoalkeeper: false,
    teamShortName: "mer",
  },
  {
    number: 11,
    firstName: "Taycan",
    lastName: "Yilmaz",
    birthday: "2007-08-29",
    isGoalkeeper: false,
    teamShortName: "mer",
  },
  {
    number: 21,
    firstName: "Ilwan",
    lastName: "Ertem",
    birthday: "2001-12-13",
    isGoalkeeper: false,
    teamShortName: "mer",
  },
  {
    number: 22,
    firstName: "Kilian",
    lastName: "Berner",
    birthday: "2006-01-14",
    isGoalkeeper: false,
    teamShortName: "mer",
  },
  {
    number: 4,
    firstName: "Fabian",
    lastName: "Bieck",
    birthday: "2005-01-12",
    isGoalkeeper: false,
    teamShortName: "het",
  },
  {
    number: 9,
    firstName: "Florian",
    lastName: "Murati",
    birthday: "2006-10-10",
    isGoalkeeper: false,
    teamShortName: "het",
  },
  {
    number: 10,
    firstName: "Jonas",
    lastName: "Prib",
    birthday: "2004-02-11",
    isGoalkeeper: false,
    teamShortName: "het",
  },
  {
    number: 6,
    firstName: "Leon",
    lastName: "Giesbrecht",
    birthday: "2006-01-11",
    isGoalkeeper: false,
    teamShortName: "het",
  },
  {
    number: 11,
    firstName: "Max",
    lastName: "Klipker",
    birthday: "2004-05-12",
    isGoalkeeper: false,
    teamShortName: "het",
  },
  {
    number: 7,
    firstName: "Nderim",
    lastName: "Ahmetaj",
    birthday: "2007-08-30",
    isGoalkeeper: false,
    teamShortName: "het",
  },
  {
    number: 5,
    firstName: "Noah",
    lastName: "Klein",
    birthday: "2005-12-19",
    isGoalkeeper: false,
    teamShortName: "het",
  },
  {
    number: 8,
    firstName: "Ole-Matthis",
    lastName: "Twenning",
    birthday: "2005-11-26",
    isGoalkeeper: false,
    teamShortName: "het",
  },
  {
    number: 1,
    firstName: "Pascal",
    lastName: "Pöppel",
    birthday: "2004-01-16",
    isGoalkeeper: true,
    teamShortName: "het",
  },
];
